import React, { FunctionComponent, useCallback } from 'react'
import Switch, { ReactSwitchProps } from 'react-switch'
import * as constants from 'view/styles/constants'
import { Field, InputProps } from '../inputs'
import { LabelPosition } from 'view/styles/constants'

interface ToggleProps extends InputProps, Omit<ReactSwitchProps, 'onChange'> {}

export const Toggle: FunctionComponent<ToggleProps> = props => {
  const { id, className, readOnly, validationIssues, onChange, onUpdate, checked = false, disabled, dataTestId, ...switchProps } = props

  const handleChange = useCallback(
    (isChecked: boolean) => {
      if (onChange) {
        onChange()
      }
      if (onUpdate) {
        onUpdate(isChecked)
      }
    },
    [onChange, onUpdate]
  )

  return (
    <Switch
      id={id}
      uncheckedIcon={false}
      checkedIcon={false}
      onColor={constants.ACCENT_GOOD}
      offColor={constants.CORE_PRIMARY_4}
      height={20}
      width={36}
      handleDiameter={18}
      onChange={handleChange}
      disabled={disabled || readOnly}
      checked={disabled ? false : !!checked}
      data-test-id={dataTestId}
      {...switchProps}
    />
  )
}

export const ToggleField = Field(Toggle, { defaultLabelPosition: LabelPosition.Left })
